module.exports = __webpack_public_path__ + "static/media/image02withsquare.22daaf5c.png";